
import { useMemo } from "react";

const CommonPagination = ({
  page = 1,
  limit = 50,
  totalRecords = 0,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalRecords / limit);

  const pages = useMemo(() => {
    const result = [];
    const start = Math.max(1, page - 2);
    const end = Math.min(totalPages, page + 2);

    for (let i = start; i <= end; i++) {
      result.push(i);
    }

    return result;
  }, [page, totalPages]);

  if (totalPages === 0) {
    return (
      <div className="flex justify-center items-center px-4 py-3 text-sm text-gray-500 border-t border-gray-200">
        No records found
      </div>
    );
  }

 const buttonClass =
  "flex items-center justify-center w-10 h-10 px-2 rounded-md border border-gray-300 text-sm transition disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100";
  return (
    <div className="flex w-full items-center justify-center border-t border-gray-200 px-4 py-3">
      <div className="flex flex-wrap items-center justify-center gap-1">
        {/* First page */}
        <button
          type="button"
          className={buttonClass}
          disabled={page <= 1}
          onClick={() => onPageChange(1)}
          aria-label="First page"
        >
          «
        </button>

        {/* Previous page */}
        <button
          type="button"
          className={buttonClass}
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          aria-label="Previous page"
        >
          ‹
        </button>

        {/* First page and ellipsis */}
        {pages.length > 0 && pages[0] > 1 && (
          <>
            <button
              type="button"
              className={buttonClass}
              onClick={() => onPageChange(1)}
            >
              1
            </button>

            {pages[0] > 2 && (
              <span className="px-1 text-gray-500">…</span>
            )}
          </>
        )}

        {/* Page numbers */}
        {pages.map((pageNumber) => (
          <button
            key={pageNumber}
            type="button"
            onClick={() => onPageChange(pageNumber)}
            aria-current={pageNumber === page ? "page" : undefined}
            className={`${buttonClass} ${
              pageNumber === page
                ? "border-green-600 bg-green-600 text-white hover:bg-green-700"
                : "text-gray-700"
            }`}
          >
            {pageNumber}
          </button>
        ))}

        {/* Ellipsis and last page */}
        {pages.length > 0 &&
          pages[pages.length - 1] < totalPages && (
            <>
              {pages[pages.length - 1] < totalPages - 1 && (
                <span className="px-1 text-gray-500">…</span>
              )}

              <button
                type="button"
                className={buttonClass}
                onClick={() => onPageChange(totalPages)}
              >
                {totalPages}
              </button>
            </>
          )}

        {/* Next page */}
        <button
          type="button"
          className={buttonClass}
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          aria-label="Next page"
        >
          ›
        </button>

        {/* Last page */}
        <button
          type="button"
          className={buttonClass}
          disabled={page >= totalPages}
          onClick={() => onPageChange(totalPages)}
          aria-label="Last page"
        >
          »
        </button>
      </div>
    </div>
  );
};

export default CommonPagination;
